import React, {useEffect} from "react";
import {useSearchLogsReportPageQuery} from "../../store/backend-api/backend.api";
import {useFiltersActions} from "../../hooks/useFiltersActions";
import {useAppSelector} from "../../hooks/useAppSelector";
import {TableFilterKey} from "../../model/filters/TableFiltersDefinitions";
import {GuideTopBox} from "../../components/ui/table-components/GuideTopBox";
import {useFilterNodesActions} from "../../hooks/useMenuFiltersActions";
import {useDataActions} from "../../hooks/useDataActions";
import {DEFAULT_LOGS_FILTER} from "../../model/filters/DefaultFilters";
import {MultiSelect} from "../../components/ui/form-components/standalone/MultiSelect";
import {OptionType} from "../../model/option-type/OptionType";
import {tablePageStyle} from "../../utils/TailwindStyles";
import {LogsTable} from "../../components/logs/LogsTable";
import {HttpMethod} from "../../model/logs/Logs";
import {SeparatedDatePicker} from "../../components/ui/form-components/standalone/SeparatedDatePicker";

const selectOptions = Object.values(HttpMethod).map((value) => ({
    label: value,
    value: value,
}));

export function LogsReport() {
    const {updateFilterAndClearData} = useFiltersActions();
    const {addFiltersToMenu} = useFilterNodesActions();
    const {addData} = useDataActions();

    const state = useAppSelector(state => state.sessionStorage.filters);
    const filter = state[TableFilterKey.LOGS_FILTER].filter;

    const data = useAppSelector(state => state.data.data[TableFilterKey.LOGS_FILTER]);

    const {data: tablePage} = useSearchLogsReportPageQuery(filter);

    useEffect(() => {
        addFiltersToMenu({
            key: TableFilterKey.LOGS_FILTER,
            value: [
                {
                    filterName: "Метод запроса",
                    filter: <MultiSelect options={selectOptions}
                                         onChange={(options: readonly OptionType<HttpMethod>[] | null) => {
                                             updateFilterAndClearData({
                                                 key: TableFilterKey.LOGS_FILTER,
                                                 value: {
                                                     ...filter,
                                                     method: options ? options.map(option => option.value) : []
                                                 }
                                             })
                                         }}
                                         width={"270px"}
                                         defaultOptions={filter.method.map(method => ({
                                             label: method,
                                             value: method
                                         }))}
                    />
                }, {
                    filterName: "Время запроса",
                    filter: <SeparatedDatePicker
                        onChange={(startDate: Date | null, endDate: Date | null) => {
                            updateFilterAndClearData({
                                key: TableFilterKey.LOGS_FILTER,
                                value: {
                                    ...filter,
                                    timeFrom: startDate ? startDate.toISOString().slice(0, 10) : null,
                                    timeTo: endDate ? endDate.toISOString().slice(0, 10) : null
                                }
                            })
                        }}
                        startDate={filter.timeFrom ? new Date(filter.timeFrom) : undefined}
                        endDate={filter.timeTo ? new Date(filter.timeTo) : undefined}
                    />
                },
            ]
        })
    }, [filter]);

    useEffect(() => {
        if (tablePage) {
            if (!data || data.rows.length < (tablePage.pageNumber * DEFAULT_LOGS_FILTER.pageSize) + 1) {
                addData({key: TableFilterKey.LOGS_FILTER, data: tablePage})
            }
        }

    }, [tablePage]);

    return (<>
        <div className={tablePageStyle}>
            <GuideTopBox tableFilterKey={TableFilterKey.LOGS_FILTER}
                         searchInfo={"Поиск по всем полям, кроме времени запроса."}/>
            {data &&
                <LogsTable data={data} />}
        </div>
    </>)
}